var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEventLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0399 12.9602C11.4067 14.327 13.6228 14.327 14.9896 12.9602L18.5252 9.42462C19.892 8.05779 19.892 5.84171 18.5252 4.47487C17.1583 3.10804 14.9423 3.10804 13.5754 4.47487L11.8077 6.24264",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8683 10.1316C11.5015 8.76481 9.28541 8.76481 7.91857 10.1316L4.38304 13.6672C3.0162 15.034 3.0162 17.2501 4.38304 18.6169C5.74987 19.9838 7.96595 19.9838 9.33278 18.6169L11.1006 16.8492",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventLink);
export default __webpack_public_path__ + "static/media/EventLink.e91aaaa733cafe47addf71070044d5c8.svg";
export { ForwardRef as ReactComponent };